<template>
    <div
        v-animation:bottom.delay
        class="t-lk-online-courses-id__head"
        v-if="course"
    >
        <img v-if="course.img" class="t-lk-online-courses-id__img t-object-fit-cover" :src="course.img" :alt="course.title">
        <div class="t-lk-online-courses-id__row">
            <p class="t-lk-online-courses-id__type" v-if="course.type">{{ course.type }}</p>
            <button
                type="button"
                :class="['t-lk-online-courses-id__add-favorite', {_active: course.isFavorite}]"
                @click="toggleFavorite"
            >
                <transition-group name="fadeChange" tag="p">
                    <svg v-if="course.isFavorite" :key="1" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0001 1.6001C16.4061 1.6001 16.7769 1.83057 16.9566 2.19463L20.8287 10.039L29.4877 11.3046C29.8894 11.3634 30.2229 11.645 30.3481 12.0311C30.4733 12.4172 30.3685 12.841 30.0777 13.1242L23.813 19.2261L25.2914 27.8465C25.3601 28.2467 25.1956 28.6511 24.867 28.8898C24.5385 29.1284 24.103 29.1598 23.7436 28.9708L16.0001 24.8986L8.25661 28.9708C7.89723 29.1598 7.46172 29.1284 7.13321 28.8898C6.8047 28.6511 6.64017 28.2467 6.70881 27.8465L8.1873 19.2261L1.92255 13.1242C1.63175 12.841 1.52693 12.4172 1.65213 12.0311C1.77734 11.645 2.11086 11.3634 2.51253 11.3046L11.1716 10.039L15.0436 2.19463C15.2233 1.83057 15.5941 1.6001 16.0001 1.6001Z" fill="#FFF"></path>
                    </svg>
                    <svg v-else :key="2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 1.7002C12.3047 1.7002 12.5828 1.87305 12.7176 2.1461L15.6216 8.02937L22.1159 8.97861C22.4172 9.02264 22.6673 9.23384 22.7612 9.52345C22.8551 9.81306 22.7765 10.1309 22.5584 10.3433L17.8598 14.9197L18.9687 21.385C19.0202 21.6851 18.8968 21.9885 18.6504 22.1674C18.404 22.3464 18.0774 22.37 17.8079 22.2283L12.0002 19.1741L6.19258 22.2283C5.92305 22.37 5.59641 22.3464 5.35003 22.1674C5.10365 21.9885 4.98025 21.6851 5.03173 21.385L6.1406 14.9197L1.44203 10.3433C1.22394 10.1309 1.14532 9.81306 1.23922 9.52345C1.33312 9.23384 1.58327 9.02264 1.88452 8.97861L8.37881 8.02937L11.2829 2.1461C11.4176 1.87305 11.6957 1.7002 12.0002 1.7002ZM12.0002 4.3076L9.62758 9.1143C9.51115 9.35017 9.2862 9.51374 9.02592 9.55178L3.71895 10.3275L7.5584 14.0671C7.7471 14.2509 7.83323 14.5158 7.7887 14.7754L6.88276 20.0575L11.6279 17.5621C11.861 17.4395 12.1395 17.4395 12.3726 17.5621L17.1177 20.0575L16.2117 14.7754C16.1672 14.5158 16.2533 14.2509 16.442 14.0671L20.2815 10.3275L14.9745 9.55178C14.7142 9.51374 14.4893 9.35017 14.3729 9.1143L12.0002 4.3076Z" fill="white"/>
                    </svg>
                    <span v-if="course.isFavorite" :key="3">{{ $root.staticText.lk.materialsOnlineCoursesFavoriteRemove }}</span>
                    <span v-else :key="4">{{ $root.staticText.lk.materialsOnlineCoursesFavoriteAdd }}</span>
                </transition-group>
            </button>
        </div>
        <h1 class="t-lk-online-courses-id__title">{{ course.title }}</h1>
        <div class="t-lk-online-courses-id__desc">
            <p class="_decor" v-if="course.time">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 6.66667V10L12.5 12.5M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z" stroke="#C0C0CC" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ course.time }}</span>
            </p>
            <p v-if="course.files && course.files.length">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.66634 5.83333V12.5C6.66634 12.942 6.84194 13.366 7.1545 13.6785C7.46706 13.9911 7.89098 14.1667 8.33301 14.1667H13.333M6.66634 5.83333V4.16667C6.66634 3.72464 6.84194 3.30072 7.1545 2.98816C7.46706 2.67559 7.89098 2.5 8.33301 2.5H12.1547C12.3757 2.50005 12.5876 2.58788 12.7438 2.74417L16.4222 6.4225C16.5785 6.57874 16.6663 6.79067 16.6663 7.01167V12.5C16.6663 12.942 16.4907 13.366 16.1782 13.6785C15.8656 13.9911 15.4417 14.1667 14.9997 14.1667H13.333M6.66634 5.83333H4.99967C4.55765 5.83333 4.13372 6.00893 3.82116 6.32149C3.5086 6.63405 3.33301 7.05797 3.33301 7.5V15.8333C3.33301 16.2754 3.5086 16.6993 3.82116 17.0118C4.13372 17.3244 4.55765 17.5 4.99967 17.5H11.6663C12.1084 17.5 12.5323 17.3244 12.8449 17.0118C13.1574 16.6993 13.333 16.2754 13.333 15.8333V14.1667" stroke="#C0C0CC" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ course.files.length }} {{ declOfNum(course.files.length, $root.staticText.lk.materialsWords) }}</span>
            </p>
        </div>
    </div>
</template>

<script>

import Vue from "vue";

export default {
    name: "lk-course-head",
    props: {
        course: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        declOfNum(number, words) {
            return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
        },
        toggleFavorite() {
            let url = 'lk/materials-online-courses/addFavorite';

            if (this.course.isFavorite) {
                url = 'lk/materials-online-courses/removeFavorite';
            }

            let fd = new FormData();
            fd.append('id', this.course.id);

            Vue.http.post(url, fd)
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        this.$emit('toggleFavorites', !this.course.isFavorite);
                    }
                })
                .catch(() => {});
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/templates/components/lk/lk-course/lk-course-head/lk-course-head.vue